import React, { useState, useRef } from "react";
import {
  TextField,
  InputAdornment,
  IconButton,
  Snackbar,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const CopyTextField = ({ value, label }) => {
  const inputRef = useRef();
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(inputRef.current.value);
    setCopied(true);
  };

  const handleClose = () => {
    setCopied(false);
  };

  return (
    <>
      <TextField
        variant="standard"
        inputRef={inputRef}
        label={label}
        fullWidth
        value={value}
        margin="normal"
        InputProps={{
          style: {marginTop:'1rem'},
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={handleCopy}>
                <ContentCopyIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        sx={{
          color: 'rgba(70, 70, 70, 0.60)',
          fontWeight: '400',
          '& .MuiInputLabel-root.Mui-focused': {
            color: 'rgba(70, 70, 70, 0.60)',
            fontWeight: '400'
          }
        }}
      />
      <Snackbar
        open={copied}
        autoHideDuration={2000}
        onClose={handleClose}
        message="Copiado!"
      />
    </>
  );
};

export default CopyTextField;
